/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }

function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));) { ; } return t; }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var k = require("@lexical/utils"),
    n = require("lexical");

var p = new Set(["http:", "https:", "mailto:", "sms:", "tel:"]);

var q = /*#__PURE__*/function (_n$ElementNode) {
  _inherits(q, _n$ElementNode);

  var _super = _createSuper(q);

  function q(a) {
    var _this;

    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var d = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, q);

    _this = _super.call(this, d);
    var _b$target = b.target,
        l = _b$target === void 0 ? null : _b$target,
        _b$rel = b.rel,
        h = _b$rel === void 0 ? null : _b$rel,
        _b$title = b.title,
        e = _b$title === void 0 ? null : _b$title;
    _this.__url = a;
    _this.__target = l;
    _this.__rel = h;
    _this.__title = e;
    return _this;
  }

  _createClass(q, [{
    key: "createDOM",
    value: function createDOM(a) {
      var b = document.createElement("a");
      b.href = this.sanitizeUrl(this.__url);
      null !== this.__target && (b.target = this.__target);
      null !== this.__rel && (b.rel = this.__rel);
      null !== this.__title && (b.title = this.__title);
      k.addClassNamesToElement(b, a.theme.link);
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b) {
      var d = this.__url,
          l = this.__target,
          h = this.__rel,
          e = this.__title;
      d !== a.__url && (b.href = d);
      l !== a.__target && (l ? b.target = l : b.removeAttribute("target"));
      h !== a.__rel && (h ? b.rel = h : b.removeAttribute("rel"));
      e !== a.__title && (e ? b.title = e : b.removeAttribute("title"));
      return !1;
    }
  }, {
    key: "sanitizeUrl",
    value: function sanitizeUrl(a) {
      try {
        var b = new URL(a);
        if (!p.has(b.protocol)) return "about:blank";
      } catch (_unused) {}

      return a;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(q.prototype), "exportJSON", this).call(this)), {}, {
        rel: this.getRel(),
        target: this.getTarget(),
        title: this.getTitle(),
        type: "link",
        url: this.getURL(),
        version: 1
      });
    }
  }, {
    key: "getURL",
    value: function getURL() {
      return this.getLatest().__url;
    }
  }, {
    key: "setURL",
    value: function setURL(a) {
      this.getWritable().__url = a;
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      return this.getLatest().__target;
    }
  }, {
    key: "setTarget",
    value: function setTarget(a) {
      this.getWritable().__target = a;
    }
  }, {
    key: "getRel",
    value: function getRel() {
      return this.getLatest().__rel;
    }
  }, {
    key: "setRel",
    value: function setRel(a) {
      this.getWritable().__rel = a;
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.getLatest().__title;
    }
  }, {
    key: "setTitle",
    value: function setTitle(a) {
      this.getWritable().__title = a;
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      a = this.getParentOrThrow().insertNewAfter(a, b);
      return n.$isElementNode(a) ? (b = t(this.__url, {
        rel: this.__rel,
        target: this.__target,
        title: this.__title
      }), a.append(b), b) : null;
    }
  }, {
    key: "canInsertTextBefore",
    value: function canInsertTextBefore() {
      return !1;
    }
  }, {
    key: "canInsertTextAfter",
    value: function canInsertTextAfter() {
      return !1;
    }
  }, {
    key: "canBeEmpty",
    value: function canBeEmpty() {
      return !1;
    }
  }, {
    key: "isInline",
    value: function isInline() {
      return !0;
    }
  }, {
    key: "extractWithChild",
    value: function extractWithChild(a, b) {
      if (!n.$isRangeSelection(b)) return !1;
      a = b.anchor.getNode();
      var d = b.focus.getNode();
      return this.isParentOf(a) && this.isParentOf(d) && 0 < b.getTextContent().length;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "link";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new q(a.__url, {
        rel: a.__rel,
        target: a.__target,
        title: a.__title
      }, a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        a: function a() {
          return {
            conversion: r,
            priority: 1
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = t(a.url, {
        rel: a.rel,
        target: a.target,
        title: a.title
      });
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return q;
}(n.ElementNode);

function r(a) {
  var b = null;

  if (k.isHTMLAnchorElement(a)) {
    var d = a.textContent;
    null !== d && "" !== d && (b = t(a.getAttribute("href") || "", {
      rel: a.getAttribute("rel"),
      target: a.getAttribute("target"),
      title: a.getAttribute("title")
    }));
  }

  return {
    node: b
  };
}

function t(a, b) {
  return n.$applyNodeReplacement(new q(a, b));
}

function v(a) {
  return a instanceof q;
}

var w = /*#__PURE__*/function (_q) {
  _inherits(w, _q);

  var _super2 = _createSuper(w);

  function w() {
    _classCallCheck(this, w);

    return _super2.apply(this, arguments);
  }

  _createClass(w, [{
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(w.prototype), "exportJSON", this).call(this)), {}, {
        type: "autolink",
        version: 1
      });
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      a = this.getParentOrThrow().insertNewAfter(a, b);
      return n.$isElementNode(a) ? (b = x(this.__url, {
        rel: this._rel,
        target: this.__target,
        title: this.__title
      }), a.append(b), b) : null;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "autolink";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new w(a.__url, {
        rel: a.__rel,
        target: a.__target,
        title: a.__title
      }, a.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = x(a.url, {
        rel: a.rel,
        target: a.target,
        title: a.title
      });
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return null;
    }
  }]);

  return w;
}(q);

function x(a, b) {
  return n.$applyNodeReplacement(new w(a, b));
}

var y = n.createCommand("TOGGLE_LINK_COMMAND");

function z(a, b) {
  for (; null !== a && null !== (a = a.getParent()) && !b(a);) {
    ;
  }

  return a;
}

exports.$createAutoLinkNode = x;
exports.$createLinkNode = t;

exports.$isAutoLinkNode = function (a) {
  return a instanceof w;
};

exports.$isLinkNode = v;
exports.AutoLinkNode = w;
exports.LinkNode = q;
exports.TOGGLE_LINK_COMMAND = y;

exports.toggleLink = function (a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _b = b,
      d = _b.target,
      l = _b.title,
      h = void 0 === b.rel ? "noreferrer" : b.rel;
  b = n.$getSelection();
  if (n.$isRangeSelection(b)) if (b = b.extract(), null === a) b.forEach(function (m) {
    m = m.getParent();

    if (v(m)) {
      var c = m.getChildren();

      for (var f = 0; f < c.length; f++) {
        m.insertBefore(c[f]);
      }

      m.remove();
    }
  });else {
    if (1 === b.length) {
      var e = b[0];
      e = v(e) ? e : z(e, v);

      if (null !== e) {
        e.setURL(a);
        void 0 !== d && e.setTarget(d);
        null !== h && e.setRel(h);
        void 0 !== l && e.setTitle(l);
        return;
      }
    }

    var m = null,
        c = null;
    b.forEach(function (f) {
      var g = f.getParent();
      if (g !== c && null !== g && (!n.$isElementNode(f) || f.isInline())) if (v(g)) c = g, g.setURL(a), void 0 !== d && g.setTarget(d), null !== h && c.setRel(h), void 0 !== l && c.setTitle(l);else if (g.is(m) || (m = g, c = t(a, {
        rel: h,
        target: d
      }), v(g) ? null === f.getPreviousSibling() ? g.insertBefore(c) : g.insertAfter(c) : f.insertBefore(c)), v(f)) {
        if (!f.is(c)) {
          if (null !== c) {
            g = f.getChildren();

            for (var u = 0; u < g.length; u++) {
              c.append(g[u]);
            }
          }

          f.remove();
        }
      } else null !== c && c.append(f);
    });
  }
};